/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { withoutUndefinedValues } from "@pagopa/ts-commons/lib/types";
import {
  RequestParams,
  TypeofApiCall,
  TypeofApiParams,
  createFetchRequestForApi,
  ReplaceRequestParams
} from "@pagopa/ts-commons/lib/requests";
import { identity } from "fp-ts/lib/function";

import {
  GetPaymentRequestInfoAuthT,
  getPaymentRequestInfoAuthDefaultDecoder,
  NewTransactionAuthT,
  newTransactionAuthDefaultDecoder,
  GetAllPaymentMethodsAuthT,
  getAllPaymentMethodsAuthDefaultDecoder,
  CreateSessionAuthT,
  createSessionAuthDefaultDecoder
} from "./requestTypes";

// This is a placeholder for undefined when dealing with object keys
// Typescript doesn't perform well when narrowing a union type which includes string and undefined
// (example: "foo" | "bar" | undefined)
// We use this as a placeholder for type parameters indicating "no key"
type __UNDEFINED_KEY = "_____";

export type ApiOperation = TypeofApiCall<GetPaymentRequestInfoAuthT> &
  TypeofApiCall<NewTransactionAuthT> &
  TypeofApiCall<GetAllPaymentMethodsAuthT> &
  TypeofApiCall<CreateSessionAuthT>;

export type ParamKeys = keyof (TypeofApiParams<GetPaymentRequestInfoAuthT> &
  TypeofApiParams<NewTransactionAuthT> &
  TypeofApiParams<GetAllPaymentMethodsAuthT> &
  TypeofApiParams<CreateSessionAuthT>);

/**
 * Defines an adapter for TypeofApiCall which omit one or more parameters in the signature
 * @param ApiT the type which defines the operation to expose
 * @param K the parameter to omit. undefined means no parameters will be omitted
 */
export type OmitApiCallParams<
  ApiT,
  K extends ParamKeys | __UNDEFINED_KEY = __UNDEFINED_KEY
> = (
  op: TypeofApiCall<ApiT>
) => K extends __UNDEFINED_KEY
  ? TypeofApiCall<ApiT>
  : TypeofApiCall<ReplaceRequestParams<ApiT, Omit<RequestParams<ApiT>, K>>>;

/**
 * Defines an adapter for TypeofApiCall which omit one or more parameters in the signature
 * @param ApiT the type which defines the operation to expose
 * @param K the parameter to omit. undefined means no parameters will be omitted
 */
export type WithDefaultsT<
  K extends ParamKeys | __UNDEFINED_KEY = __UNDEFINED_KEY
> = OmitApiCallParams<
  | GetPaymentRequestInfoAuthT
  | NewTransactionAuthT
  | GetAllPaymentMethodsAuthT
  | CreateSessionAuthT,
  K
>;

/**
 * Defines a collection of api operations
 * @param K name of the parameters that the Clients masks from the operations
 */
export type Client<
  K extends ParamKeys | __UNDEFINED_KEY = __UNDEFINED_KEY
> = K extends __UNDEFINED_KEY
  ? {
      readonly getPaymentRequestInfoAuth: TypeofApiCall<
        GetPaymentRequestInfoAuthT
      >;

      readonly newTransactionAuth: TypeofApiCall<NewTransactionAuthT>;

      readonly getAllPaymentMethodsAuth: TypeofApiCall<
        GetAllPaymentMethodsAuthT
      >;

      readonly createSessionAuth: TypeofApiCall<CreateSessionAuthT>;
    }
  : {
      readonly getPaymentRequestInfoAuth: TypeofApiCall<
        ReplaceRequestParams<
          GetPaymentRequestInfoAuthT,
          Omit<RequestParams<GetPaymentRequestInfoAuthT>, K>
        >
      >;

      readonly newTransactionAuth: TypeofApiCall<
        ReplaceRequestParams<
          NewTransactionAuthT,
          Omit<RequestParams<NewTransactionAuthT>, K>
        >
      >;

      readonly getAllPaymentMethodsAuth: TypeofApiCall<
        ReplaceRequestParams<
          GetAllPaymentMethodsAuthT,
          Omit<RequestParams<GetAllPaymentMethodsAuthT>, K>
        >
      >;

      readonly createSessionAuth: TypeofApiCall<
        ReplaceRequestParams<
          CreateSessionAuthT,
          Omit<RequestParams<CreateSessionAuthT>, K>
        >
      >;
    };

/**
 * Create an instance of a client
 * @param params hash map of parameters thata define the client:
 *  - baseUrl: the base url for every api call (required)
 *  - fetchApi: an implementation of the fetch() web API, depending on the platform (required)
 *  - basePath: optional path to be appended to the baseUrl
 *  - withDefaults: optional adapter to be applied to every operation, to omit some paramenters
 * @returns a collection of api operations
 */
export function createClient<K extends ParamKeys>(params: {
  baseUrl: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fetchApi: typeof fetch;
  withDefaults: WithDefaultsT<K>;
  basePath?: string;
}): Client<K>;
export function createClient(params: {
  baseUrl: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fetchApi: typeof fetch;
  withDefaults?: undefined;
  basePath?: string;
}): Client;
export function createClient<K extends ParamKeys>({
  baseUrl,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fetchApi,
  withDefaults,
  basePath = "/"
}: {
  baseUrl: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fetchApi: typeof fetch;
  withDefaults?: WithDefaultsT<K>;
  basePath?: string;
}) {
  const options = {
    baseUrl,
    fetchApi
  };

  const getPaymentRequestInfoAuthT: ReplaceRequestParams<
    GetPaymentRequestInfoAuthT,
    RequestParams<GetPaymentRequestInfoAuthT>
  > = {
    method: "get",

    headers: ({ ["bearerAuth"]: bearerAuth }) => ({
      Authorization: `Bearer ${bearerAuth}`
    }),
    response_decoder: getPaymentRequestInfoAuthDefaultDecoder(),
    url: ({ ["rpt_id"]: rptId }) => `${basePath}/payment-requests/${rptId}`,

    query: () => withoutUndefinedValues({})
  };
  const getPaymentRequestInfoAuth: TypeofApiCall<GetPaymentRequestInfoAuthT> = createFetchRequestForApi(
    getPaymentRequestInfoAuthT,
    options
  );

  const newTransactionAuthT: ReplaceRequestParams<
    NewTransactionAuthT,
    RequestParams<NewTransactionAuthT>
  > = {
    method: "post",

    headers: ({
      ["bearerAuth"]: bearerAuth,
      ["x-correlation-id"]: xCorrelationId,
      ["x-client-id-from-client"]: xClientIdFromClient,
      ["x-rpt-ids"]: xRptIds
    }) => ({
      Authorization: `Bearer ${bearerAuth}`,

      "x-correlation-id": xCorrelationId,

      "x-client-id-from-client": xClientIdFromClient,

      "x-rpt-ids": xRptIds,

      "Content-Type": "application/json"
    }),
    response_decoder: newTransactionAuthDefaultDecoder(),
    url: ({}) => `${basePath}/transactions`,

    body: ({ ["body"]: body }) =>
      body?.constructor?.name === "Readable" ||
      body?.constructor?.name === "ReadableStream"
        ? (body as ReadableStream)
        : body?.constructor?.name === "Buffer"
        ? (body as Buffer)
        : JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const newTransactionAuth: TypeofApiCall<NewTransactionAuthT> = createFetchRequestForApi(
    newTransactionAuthT,
    options
  );

  const getAllPaymentMethodsAuthT: ReplaceRequestParams<
    GetAllPaymentMethodsAuthT,
    RequestParams<GetAllPaymentMethodsAuthT>
  > = {
    method: "post",

    headers: ({ ["bearerAuth"]: bearerAuth, ["x-rpt-ids"]: xRptIds }) => ({
      Authorization: `Bearer ${bearerAuth}`,

      "x-rpt-ids": xRptIds,

      "Content-Type": "application/json"
    }),
    response_decoder: getAllPaymentMethodsAuthDefaultDecoder(),
    url: ({}) => `${basePath}/payment-methods`,

    body: ({ ["body"]: body }) =>
      body?.constructor?.name === "Readable" ||
      body?.constructor?.name === "ReadableStream"
        ? (body as ReadableStream)
        : body?.constructor?.name === "Buffer"
        ? (body as Buffer)
        : JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const getAllPaymentMethodsAuth: TypeofApiCall<GetAllPaymentMethodsAuthT> = createFetchRequestForApi(
    getAllPaymentMethodsAuthT,
    options
  );

  const createSessionAuthT: ReplaceRequestParams<
    CreateSessionAuthT,
    RequestParams<CreateSessionAuthT>
  > = {
    method: "post",

    headers: ({
      ["bearerAuth"]: bearerAuth,
      ["lang"]: lang,
      ["x-rpt-ids"]: xRptIds
    }) => ({
      Authorization: `Bearer ${bearerAuth}`,

      lang: lang,

      "x-rpt-ids": xRptIds,

      "Content-Type": "application/json"
    }),
    response_decoder: createSessionAuthDefaultDecoder(),
    url: ({ ["id"]: id }) => `${basePath}/payment-methods/${id}/sessions`,

    body: () => "{}",

    query: () => withoutUndefinedValues({})
  };
  const createSessionAuth: TypeofApiCall<CreateSessionAuthT> = createFetchRequestForApi(
    createSessionAuthT,
    options
  );

  return {
    getPaymentRequestInfoAuth: (withDefaults || identity)(
      getPaymentRequestInfoAuth
    ),
    newTransactionAuth: (withDefaults || identity)(newTransactionAuth),
    getAllPaymentMethodsAuth: (withDefaults || identity)(
      getAllPaymentMethodsAuth
    ),
    createSessionAuth: (withDefaults || identity)(createSessionAuth)
  };
}
